import { Divider } from '@/design-system/components/Divider';
import { getObjectScreenNameFromPath, popStateLockedMap } from '@/design-system/components/navigatorEmbed/UtxAppNavigatorEmbed';
import { TextBody } from '@/design-system/components/typography';
import { useFocusEffect, useNavigation } from '@react-navigation/native';
import { SxProp, View } from 'dripsy';
import _ from 'lodash';
import React, { useCallback, useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Platform } from 'react-native';
import BillPaymentApp from '../..';
import { BillPaymentStackRoutes } from '@/features/bill-payment/payment.navigator';
import { mapUrlLink, onGoBack } from '@/features/bill-payment/utils/utils';
import { LayoutContext } from 'contexts/LayoutContext';
import { NativeModalView } from '@/design-system/components/modal/nativeModal/NativeModalView';
import { useNativeModalView } from '@/design-system/components/modal/nativeModal/useNativeModalView';
import { BottomSheetHeader } from '@/design-system/components/headers';
import BottomSheet, { useBottomSheetDynamicSnapPoints, BottomSheetBackdrop } from '@gorhom/bottom-sheet';
import { UtxAppEmbed } from '@/design-system/components/utxAppEmbedCallback/utxAppEmbedCallback';

export interface UnionPayMoreNativeProps {}

export const UnionPayMoreMobileComponent: React.FC<UnionPayMoreNativeProps> = ({}) => {
  const { t } = useTranslation('bill-payment-union-pay');
  const navigation = useNavigation();

  const onBack = () => {
    if (Platform.OS === 'web') {
      popStateLockedMap.set('popstate', true);
      onGoBack(navigation);
      setTimeout(() => popStateLockedMap.set('popstate', false), 500);
    } else {
      onGoBack(navigation);
    }
  };

  const onPopState = (event: any) => {
    window.history.pushState(event.state, '');
    setTimeout(() => {
      const popStateLocked = popStateLockedMap.get('popstate') ?? false;
      if (!document.location.href || popStateLocked) return;
      const { parentName, subName } = mapUrlLink(document.location.href);
      var screenNameObject = getObjectScreenNameFromPath([BillPaymentApp], `/${subName}`);
      if (
        screenNameObject.screenName &&
        screenNameObject.routeStackName === parentName &&
        screenNameObject.screenName !== BillPaymentStackRoutes.Landing
      ) {
        onBack();
      }
    }, 200);
  };

  useFocusEffect(
    useCallback(() => {
      if (Platform.OS === 'web') {
        window.addEventListener('popstate', onPopState);
        return () => {
          window.removeEventListener('popstate', onPopState);
        };
      }
    }, [])
  );

  const layout = useContext(LayoutContext);
  const renderBackdrop = useCallback(
    (props) => <BottomSheetBackdrop {...props} disappearsOnIndex={0} appearsOnIndex={1} pressBehavior={'none'} enableTouchThrough={true} />,
    []
  );
  const { width, height } = layout.dimensions;
  const { animatedHandleHeight, animatedSnapPoints, animatedContentHeight, handleContentLayout } = useBottomSheetDynamicSnapPoints([
    'CONTENT_HEIGHT',
    'CONTENT_HEIGHT'
  ]);

  const { animatedStyle, handleBack } = useNativeModalView({});

  return (
    <NativeModalView animatedStyle={animatedStyle} onBack={handleBack} showHeader={false}>
      <UtxAppEmbed>
        <View sx={{ width, height, backgroundColor: 'transparent' }}>
          <BottomSheet
            enablePanDownToClose
            index={1}
            snapPoints={animatedSnapPoints}
            handleHeight={animatedHandleHeight}
            contentHeight={animatedContentHeight}
            backdropComponent={renderBackdrop}
            handleComponent={() => <View />}>
            <View sx={sxStyles.modal}>
              <View sx={{ ...sxStyles.container, minHeight: 176 }} onLayout={handleContentLayout}>
                <View>
                  <BottomSheetHeader title="" onPress={() => onBack()} />
                </View>
                <View sx={{ alignItems: 'center', gap: '$4' }}>
                  <TextBody sx={{ color: '$textPrimary' }}>{t('unionPay::payment-instruction.text--unionpay-payment-faq')}</TextBody>
                  <Divider sx={{ margin: 'auto', backgroundColor: '$borderField', width: '80%' }} />
                  <TextBody sx={{ color: '$textPrimary' }}>
                    {t('unionPay::payment-instruction.text--quit-unionpay-payment-instruction')}
                  </TextBody>
                </View>
              </View>
            </View>
          </BottomSheet>
        </View>
      </UtxAppEmbed>
    </NativeModalView>
  );
};

const sxStyles: Record<string, SxProp> = {
  modal: {
    width: '100%',
    padding: '$4'
  },
  container: {
    backgroundColor: '$backgroundPrimary'
  }
};
